import product_img1 from "../components/images/porductimg/img1.webp";
import product_img2 from "../components/images/porductimg/img2.webp";
import product_img3 from "../components/images/porductimg/img3.webp";
import product_img4 from "../components/images/porductimg/img4.webp";
import product_img5 from "../components/images/porductimg/img5.webp";
import product_img6 from "../components/images/porductimg/img6.webp";
import product_img7 from "../components/images/porductimg/img7.webp";
import product_img8 from "../components/images/porductimg/img8.webp";
import product_img9 from "../components/images/porductimg/img9.webp";
import product_img10_1 from "../components/images/porductimg/img10-1.webp";
import product_img10 from "../components/images/porductimg/img10.webp";
import product_img11 from "../components/images/porductimg/img11.webp";
import product_img12 from "../components/images/porductimg/img12.webp";
import product_img13 from "../components/images/porductimg/img13.webp";

import chage1 from "../components/images/change/Bio Safety.webp";
import chage2 from "../components/images/change/Laminar Airflow 2.webp";
import chage3 from "../components/images/change/operation Theatre laminar airflow.webp";
import chage4 from "../components/images/change/Air Curtains.webp";
import chage5 from "../components/images/change/ceiling-suspended-laminar-flow.webp";
import chage6 from "../components/images/change/Pressure module.webp";
import chage7 from "../components/images/change/Air flow units.webp";

import chage8 from "../components/images/id2/img (2).webp";

import pr1bg1 from "../components/images/id1/img (1).webp";
import pr1bg2 from "../components/images/id1/img (2).webp";
import pr1bg3 from "../components/images/id1/img (3).webp";
import pr1bg4 from "../components/images/id1/img (4).webp";

import pr2bg1 from "../components/images/id2/img (1).webp";
import pr2bg2 from "../components/images/id2/img (2).webp";

import pr3bg1 from "../components/images/id3/img (1).webp";
import pr3bg2 from "../components/images/id3/img (2).webp";
import pr3bg3 from "../components/images/id3/img (3).webp";
import pr3bg4 from "../components/images/id3/img (4).webp";

import pr4bg2 from "../components/images/id4/img (2).webp";
import pr4bg3 from "../components/images/id4/img (3).webp";
import pr4bg4 from "../components/images/id4/img (4).webp";

import pr5bg1 from "../components/images/id5/img (1).webp";
import pr5bg2 from "../components/images/id5/img (2).webp";

import pr6bg1 from "../components/images/id6/img (1).webp";
import pr6bg2 from "../components/images/id6/img (2).webp";
import pr6bg3 from "../components/images/id6/img (3).webp";

import pr7bg1 from "../components/images/id7/img (1).webp";
import pr7bg2 from "../components/images/id7/img (2).webp";

import pr8bg1 from "../components/images/id8/img (1).webp";
import pr8bg2 from "../components/images/id8/img (2).webp";
import pr8bg3 from "../components/images/id8/img (3).webp";

import pr9bg1 from "../components/images/id9/img (1).webp";
import pr9bg2 from "../components/images/id9/img (2).webp";
import pr9bg3 from "../components/images/id9/img (3).webp";
import pr9bg4 from "../components/images/id9/img (4).webp";

import pr10bg1 from "../components/images/id10/img (1).webp";
import pr10bg2 from "../components/images/id10/img (2).webp";
import pr10bg3 from "../components/images/id10/img (3).webp";

import pr11bg1 from "../components/images/id11/img (1).webp";
import pr11bg2 from "../components/images/id11/img (2).webp";

import pr13bg1 from "../components/images/id13/img (1).webp";
import pr13bg2 from "../components/images/id13/img (2).webp";
import pr13bg3 from "../components/images/id13/img (3).webp";


const productData = {
  products: [
    {
      id: "product-1",
      image: product_img12,
      alt: "Laminar Airflow Image",
      title: "Laminar Airflow",
      url: "laminar-airflow",
      relateproimage: [
        pr1bg1,pr1bg2,pr1bg3,pr1bg4
      ],
      description: `
      <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
        <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Laminar Airflow</h1>

        <p class="!text-[18px] !leading-[32px] !font-medium">
          CLEANFLOW assures full product protection such as basic microbial contamination not recommended for operator / environment protection. Continuous flushing of the working area by a unidirectional and ultra-filtered airflow allows in sterile and particle free conditions. The Airflow pattern will be 100% supply & 0% exhaust.
        </p>

        <p class="!text-[18px] !leading-[32px] !font-medium">
        <span class="text-black  font-['Neue Montreal'] mb-[16px] text-[18px] font-bold leading-[28px]">Vertical Laminar Airflow</span> cabinets are generally used for applications like Microbiological culture and Non-hazardous analytical application.
        </p>
        <p class="!text-[18px] !leading-[32px] !font-medium">
        <span class="text-black  font-['Neue Montreal'] mb-[16px] text-[18px] font-bold leading-[28px]">Horizontal Laminar Airflow</span> cabinets are generally used for applications like Plant Tissue culture, Non-hazardous analytical applications
        </p>

        <table class="w-full text-left border-collapse md:!w-[500px]">
          <thead>
            <tr class="bg-[#1595B2]">
              <th class="p-2 border text-center text-white text-[16px] !font-medium">Model No</th>
              <th class="p-2 border text-center text-white text-[16px]  !font-medium">Working sizes</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFV / CH 600</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2 x 2 x 2</td>
            </tr>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFV / CH 900</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">3 x 2 x 2</td>
            </tr>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFV / CH 1200</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">4 x 2 x 2</td>
            </tr>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFV / CH 1800</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">6 x 2 x 2</td>
            </tr>
          </tbody>
        </table>

        <div class="mt-4 text-black">
          <p class="!text-[18px] !leading-[32px] !font-bold">* Custom sizes are also available</p>
          <p class="!text-[18px] !leading-[32px] !font-medium">
            Special features available such as fully automatic motorized sliding front door, sensor-based digital differential pressure monitoring system, PLC based control panel with
          </p>
        </div>
        </div>
      </section>
      `
    },
    {
      id: "product-2",
      image: product_img2,
      alt: "Bio Safety Cabinet Image",
      title: "Bio Safety Cabinet",
      url: "bio-safety-cabinet",
      destwoimg: chage1,
      desthreeimg: chage8,
      relateproimage: [
        pr2bg1,pr2bg2
      ],
      descriptionone: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Bio Safety Cabinet</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Biosafety cabinets are biocontainment equipment used in biological laboratories to provide personnel, environmental, and product protection. It is considered one of the most important engineering controls used to prevent exposure to contamination by biohazardous agents. It is used whenever there is a risk of splash or aerosol formation from bio-hazardous or potentially biohazardous materials in a laboratory atmosphere. Biosafety cabinets are equipped with germicidal UV-C lamps with wavelength of 254 nm to decontaminate the interior surface.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Cleans Biosafety Cabinets are made from antimicrobial epoxy coated GI or IS304 SS construction. Special features include fully automatic motorized sliding front door, sensor-based digital differential pressure monitoring system, PLC-based control panel with feather-touch switches, etc.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium">Cleans Biosafety cabinets are available in the following three types:</p>

          <ul class="list-disc pl-5 mb-6 space-y-3 !text-[18px] !font-medium">
            <li>Class II Type A2 Biosafety Cabinet</li>
            <li>Class II Type B2 Biosafety Cabinet</li>
            <li>Class III Biosafety Cabinet</li>
          </ul>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            <span class="font-bold">CLEANS Class II Type A2 Biosafety Cabinet:</span><br>
            These cabinets provide personnel, product, and environment protection. 70% of the air is recirculated through HEPA filters, and 30% is exhausted. The airflow barrier and laminar zone ensure ultra-clean working conditions. Suitable for mild to low-level hazardous materials. No ducting required.
          </p>

          <table class="w-full max-w-[500px] border-collapse text-left">
            <thead>
              <tr class="bg-[#1595B2] text-white text-[16px]">
                <th class="p-2 border border-white text-center  !font-medium">Model No</th>
                <th class="p-2 border border-white text-center  !font-medium">Working sizes</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 900 A2</td>
                <td class="p-2 text-center font-[500]">3 x 2 x 2</td>
              </tr>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 1200 A2</td>
                <td class="p-2 text-center font-[500]">4 x 2 x 2</td>
              </tr>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 1800 A2</td>
                <td class="p-2 text-center font-[500]">6 x 2 x 2</td>
              </tr>
            </tbody>
          </table>

        </div>
        </section>
      `,
      descriptiontwo: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

          <p class="!text-[18px] !leading-[32px] !font-medium">
            <span class="font-bold">CLEANS Class II Type B2 Biosafety Cabinet:</span><br>
            100% air is exhausted post HEPA filtration (no recirculation). Air barrier at the work zone ensures safety. Negative pressure zones enhance containment. Ideal for low to medium hazardous non-aerosol pathogens. Ducting and virus burn-out unit recommended.
          </p>

          <table class="w-full max-w-[500px] border-collapse text-left">
            <thead>
              <tr class="bg-[#1595B2] text-white text-[16px]">
                <th class="p-2 border border-white text-center  !font-medium">Model No</th>
                <th class="p-2 border border-white text-center  !font-medium">Working sizes</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 900 B2</td>
                <td class="p-2 text-center font-[500]">3 x 2 x 2</td>
              </tr>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 1200 B2</td>
                <td class="p-2 text-center font-[500]">4 x 2 x 2</td>
              </tr>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 1800 B2</td>
                <td class="p-2 text-center font-[500]">6 x 2 x 2</td>
              </tr>
            </tbody>
          </table>

          <div class="mt-4">
            <p class="!font-medium">* Customized sizes are also available</p>
          </div>

        </div>
        </section>
      `,
      descriptionthree: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

          <div class="mt-4">
            <p class="!text-[18px] !leading-[32px] !font-bold !my-2">CLEANS Class III Biosafety Cabinet:</p>
            <p class="!text-[18px] !leading-[32px] !font-medium">
              These cabinets are fully enclosed and ventilated, operated through glove ports. Maintained under negative pressure with HEPA + ULPA filtration and incineration. Suitable for high-risk agents (HIV, SARS, cancer drugs, etc.).
            </p>

            <p class="!text-[18px] !leading-[32px] !font-medium">
              Special features include built-in virus burn-out unit, transfer hatch attachment.<br>
              Available in the following sizes:
            </p>
          </div>

          <table class="w-full max-w-[500px] border-collapse text-left mt-2">
            <thead>
              <tr class="bg-[#1595B2] text-white text-[16px]">
                <th class="p-2 border text-center  !font-medium">Model No</th>
                <th class="p-2 border text-center  !font-medium">Working sizes</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 900 III</td>
                <td class="p-2 text-center font-[500]">3 x 2 x 2</td>
              </tr>
              <tr class="border border-white bg-[#C2F0FA]">
                <td class="p-2 text-center font-[500]">CBS 1200 III</td>
                <td class="p-2 text-center font-[500]">4 x 2 x 2</td>
              </tr>
            </tbody>
          </table>
        </div>
        </section>
      `
    },
    {
      id: "product-3",
      image: product_img3,
      alt: "Fume Exhaust Hood Image",
      title: "Fume Exhaust Hood",
      url: "fume-exhaust-hood",
      relateproimage: [
        pr3bg1,pr3bg2,pr3bg3,pr3bg4
      ],
      description: `
      <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
        <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Fume Exhaust Hood</h1>

        <p class="!text-[18px] !leading-[32px] !font-medium">
          Cleans Fume Exhaust Hoods are installed in laboratories to remove chemical odors, fumes, and gases emitted during various process activities. These hoods are available in different types, including constant exhaust hoods, auxiliary bypass hoods, and low-volume exhaust hoods. Cleans Fume Hoods are fully enclosed and custom-built. Three sides are permanently sealed, while the front features a sliding sash made of toughened glass. Ventilated under-storage cabinets are also provided for storing reagents and small instruments. Fume hoods are available in both ducted and ductless configurations, and even in walk-in types.
        </p>

        <p class="!text-[18px] !leading-[32px] !font-medium">
          <span class="font-bold">Cleans Fume Hoods are available in the following constructions:</span><br>
          - Powder-coated galvanized iron with FRP/PP inner lining<br>
          - Polypropylene construction with PU paint-coated finish<br>
          - IS304 stainless steel construction
        </p>

        <p class="!text-[18px] !leading-[32px] !font-medium">
          <span class="font-bold">Available in the following sizes:</span>
        </p>

        <table class="w-full text-left border-collapse md:!w-[500px]">
          <thead>
            <tr class="bg-[#1595B2]">
              <th class="p-2 border text-center text-white text-[16px]  !font-medium">Model No</th>
              <th class="p-2 border text-center text-white text-[16px]  !font-medium">Length (mm) Inner / Outer</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFH 900</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">3 x 2 x 3</td>
            </tr>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFH 1200</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">4 x 2 x 3</td>
            </tr>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFH 1500</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">5 x 2 x 3</td>
            </tr>
            <tr class="border">
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CFH 1800</td>
              <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">6 x 2 x 3</td>
            </tr>
          </tbody>
        </table>

        <div class="mt-4 text-black">
          <p class="!font-medium">* Custom sizes are also available</p>
        </div>
        </div>
      </section>
      `
    },
    {
      id: "product-4",
      image: product_img4,
      alt: "Air Shower Image",
      title: "Air Shower",
      url: "air-shower",
      destwoimg: pr4bg3,
      relateproimage: [
        pr4bg2,pr4bg3,pr4bg4
      ],
      descriptionone: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Air Showers</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium"><strong>Single-Person Air Shower Manufacturers:</strong><br>
          Description: Designed for individual use, these air showers accommodate one person at a time.<br>
          Use Case: Ideal for small facilities or areas with low traffic, where individual decontamination is sufficient.<br>
          Design Features: Typically compact with a single entry and exit door, and equipped with nozzles to blow high-velocity air to remove particulates from clothing and equipment.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium"><strong>Three-Door Air Shower Manufacturers:</strong><br>
          Description: Air showers with three doors, usually one for entry, one for exit, and an additional door for another purpose such as an emergency exit or an alternate path.<br>
          Use Case: Provides flexibility in the layout and flow of personnel, useful in complex cleanroom setups.<br>
          Design Features: The three-door configuration allows for more versatile traffic management and can help in maintaining unidirectional flow to reduce contamination risks.
          </p>
      `,
      descriptiontwo: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

          <p class="!text-[18px] !leading-[32px] !font-medium"><strong>Roller Door Air Shower Manufacturers:</strong><br>
          Description: Equipped with roller doors that roll up and down rather than swinging open.<br>
          Use Case: Ideal for environments where space is limited or where there is a need for faster door operation to streamline the decontamination process.<br>
          Design Features: Roller doors provide efficient sealing and can be automated for improved ease of use. Also useful for facilitating the entry and exit of carts or equipment.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium"><strong>Sliding Door Air Shower Manufacturers:</strong><br>
          Description: These air showers have sliding doors that move horizontally to open and close.<br>
          Use Case: Suitable for areas with spatial constraints or where traditional hinged doors might interfere with other operations.<br>
          Design Features: Sliding doors can be automated and provide a sleek, efficient mechanism for maintaining a clean environment. They are also helpful in high-traffic areas for quick and easy access.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium"><strong>Conclusion:</strong> Each type of air shower is designed to meet specific operational needs, ensuring that personnel and equipment are properly decontaminated before entering controlled environments. The choice of air shower depends on factors such as the volume of traffic, spatial constraints, and specific cleanroom requirements.</p>
          </div>
          </section>
      `
    },
    {
      id: "product-5",
      image: product_img5,
      alt: "Pass Boxes Image",
      title: "Pass Boxes",
      url: "pass-boxes",
      relateproimage: [
        pr5bg1,pr5bg2
      ],
      description: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Pass Boxes</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
           Pass Boxes are installed to minimize traffic and contamination entry into the Cleanroom / controlled environment during transfer of raw material, pallets, etc. It acts as an air lock device preventing ambient air from entering, or clean air from exiting the clean room.
            Available in Dynamic and Static models and in various sizes.Pass Boxes are fabricated using IS 304 grade stainless steel sheet.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium"><strong>Compliant with ISO and GMP standards</strong></p>

          <p class="text-black font-['Neue Montreal'] mb-[16px] text-[18px] font-normal leading-[28px]">
            <span class="font-bold">Available in the following sizes:</span>
          </p>

          <table class="w-full text-left border-collapse md:!w-[500px]">
            <thead>
              <tr class="bg-[#1595B2]">
                <th class="p-2 border text-center text-white text-[16px] !font-medium">Model No</th>
                <th class="p-2 border text-center text-white text-[16px] !font-medium">Working Size (mm)</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">CPB 180 S</td>
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">450×450×450</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">CPB 225 S</td>
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">600×600×600</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">CPB 332 S</td>
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">900×900×900</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">CPB 442</td>
                <td class="p-[10px] text-center font-[500] border bg-[#C2F0FA]">1200×1200×1200</td>
              </tr>
            </tbody>
          </table>
          </div>
        </section>
      `
    },
    {
      id: "product-6",
      image: product_img6,
      alt: "Laboratory Modular Furniture Image",
      title: "Laboratory Modular Furniture",
      url: "laboratory-modular-furniture",
      relateproimage: [
        pr6bg1,pr6bg2,pr6bg3
      ],
      description: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Laboratory Modular Furniture</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            We are the leading manufacturers of laboratory modular furniture in Chennai, Bangalore, and Hyderabad. Our product range includes LAB tables, wall tables, island tables, instrument tables, L-shape tables, U-shape tables, and more.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Island tables are ideal for working on both sides of the table. They are designed with suspended drawer and shutter modules on both sides, along with adjustable two-tier racks for storing reagents and equipment.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            These island tables can be installed using either a pedestal system or a flexible system, depending on the user's needs and the intended use. They offer high versatility and can be customized to suit the specific requirements of different fields. Fabricated using high-quality materials, these tables are known for their durability and long-lasting performance.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Laboratory instrument tables follow a modular design, making it easy to dismantle and reassemble the modules for maintenance. We are a trusted manufacturer of instrument tables, known for offering quality designs, reliable construction, timely delivery, and professional installation.
          </p>
          </div>
        </section>
      `
    },
    {
      id: "product-7",
      image: product_img7,
      alt: "Anti Vibration Table Image",
      title: "Anti Vibration Table",
      url: "anti-vibration-table",
      relateproimage: [
       pr7bg1,pr7bg2
      ],
      description: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Anti Vibration Table</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            When employing highly sensitive laboratory balances, microscopes, and other high-precision equipment, an Anti-Vibration Table (AVT) serves as a specialized work surface designed to significantly minimize vibrations and external disturbances. These tables are crucial in laboratory environments where precision and stability are essential for accurate results. AVTs are commonly used during fine weighing procedures, delicate testing, and detailed scientific analysis. They are typically constructed from durable, shock-resistant materials such as steel, granite, and rubber to ensure optimal performance and long-term reliability.
          </p>

          </div>
        </section>
      `
    },
    {
      id: "product-8",
      image: product_img8,
      alt: "Modular Operation Theatre Image",
      title: "Modular Operation Theatre",
      url: "modular-operation-theatre",
      relateproimage: [
        pr8bg1,pr8bg2,pr8bg3
      ],
      description: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Modular Operation Theatre</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            We are leading manufacturers of Modular Operation Theater in chennai and also supplying to all over India. In the series of our products, we are engaged in manufacturing and supplying an extensive range of Modular Operation Theater. Our range of OT Laminar air flows are made of Stainless Steel 304 Sheet or GI powder coated which are exclusively used in the Modular Operation Theatre of various healthcare units and hospitals. This equipment is effective in circulating fresh, bacteria free air around the operation table of OTs, with AHU capacity depending on the class which is required based on the MOT room Size, the plenum is made available with central light arrangements or side light arrangements.
          </p>
          </div>
        </section>
      `
    },
    {
      id: "product-9",
      image: product_img9,
      destwoimg: pr9bg1,
      desthreeimg: pr9bg2,
      desfourimg: pr9bg3,
      desfiveimg: pr9bg4,
      alt: "Soft Wall Clean Rooms Image",
      title: "Soft Wall Clean Rooms",
      url: "soft-wall-clean-rooms",
      relateproimage: [
        pr9bg1,pr9bg2,pr9bg3,pr9bg4
      ],
      descriptionone: `
      <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

        <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">
          Soft Wall Clean Rooms
        </h1>

        <p class="!text-[18px] !leading-[32px] !font-medium">
          Cleanroom doors are specialized doors designed for environments that require strict control over cleanliness and contamination. These doors are commonly used in industries such as pharmaceuticals, biotechnology, healthcare, and electronics manufacturing. Cleanroom doors play a crucial role in maintaining the integrity of controlled environments by limiting the transfer of particles, microorganisms, and pollutants.
        </p>

        <p class="!text-[18px] !leading-[32px] !font-medium">
          They are constructed with materials that feature low particle emission and prevent the release of contaminants, contributing to the overall cleanliness and hygiene of the controlled spaces.
        </p>

        <h2 class="text-black font-bold font-['Neue Montreal'] text-[24px] mb-2">
          Applications of Cleanroom Doors:
        </h2>

        <ol class=" ml-6 text-black font-['Neue Montreal'] !text-[18px] !leading-[32px] !font-medium space-y-4">
          <li>
            <strong>1. Pharmaceuticals:</strong><br>
            <ul class="list-disc ml-6">
              <li><strong>Drug Manufacturing:</strong> Cleanrooms are essential for pharmaceutical companies to produce medications with precise formulations and minimal contamination.</li>
              <li>GMP-compliant Cleanroom doors are crucial for compounding sterile drugs and medicines, ensuring the purity and safety of products.</li>
            </ul>
          </li>
        </ol>

        <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
          * Customized sizes are also available.
        </p>
        </div>
      </section>
      `,
      descriptiontwo: `
      <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

        <ol class=" ml-6 text-black font-['Neue Montreal'] !text-[18px] !leading-[32px] !font-medium space-y-4">

          <li>
            <strong>2. Microelectronics and Semiconductor Manufacturing:</strong><br>
            <ul class="list-disc ml-6">
              <li><strong>Wafer Fabrication:</strong> Cleanrooms are used in semiconductor manufacturing to control airborne contaminants and optimize the fabrication of integrated circuits on silicon wafers.</li>
              <li><strong>Microprocessor Assembly:</strong> Assembling microprocessors and other electronic components requires a clean environment to prevent damage from dust and particles.</li>
            </ul>
          </li>

          <li>
            <strong>3. Biotechnology:</strong><br>
            <ul class="list-disc ml-6">
              <li><strong>Genetic Research:</strong> Cleanrooms are used in biotechnology laboratories for research involving sensitive biological materials to prevent contamination and maintain controlled conditions.</li>
              <li><strong>Cell Culture:</strong> Biotechnology is crucial in maintaining sterile conditions for cell growth and analysis.</li>
            </ul>
          </li>
        </ol>

        <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
          * Customized sizes are also available.
        </p>
        </div>
      </section>
      `,
      descriptionthree: `
      <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

        <ol class=" ml-6 text-black font-['Neue Montreal'] !text-[18px] !leading-[32px] !font-medium space-y-4">

          <li>
            <strong>4. Medical Device Manufacturing:</strong><br>
            <ul class="list-disc ml-6">
              <li>Medical devices like pacemakers, stents, and surgical tools require manufacturing in ultra-clean environments. Cleanroom doors support hygiene and particle control during assembly.</li>
              <li>Regulatory compliance: Production of medical devices must follow strict equipment guidelines, and cleanroom doors help meet high standards of quality.</li>
            </ul>
          </li>

          <li>
            <strong>5. Electronics Manufacturing:</strong><br>
            <ul class="list-disc ml-6">
              <li>Assembly of circuit boards, sensors, and microchips requires the exclusion of microscopic contaminants, ensuring the reliability of electronic components.</li>
              <li><strong>ESD Protection:</strong> Manufacturing of sensitive electronic technologies requires electrostatic discharge-safe environments.</li>
            </ul>
          </li>

        </ol>

        <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
          * Customized sizes are also available.
        </p>
        </div>
      </section>
      `,
      descriptionfour: `
      <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

        <ol class=" ml-6 text-black font-['Neue Montreal'] !text-[18px] !leading-[32px] !font-medium space-y-4">

          <li>
            <strong>6. Precision Engineering:</strong><br>
            <ul class="list-disc ml-6">
              <li>Industries like optical instruments and laser manufacturing require cleanrooms to ensure precision and protect delicate parts from particulate entry.</li>
            </ul>
          </li>

          <li>
            <strong>7. Food and Beverage:</strong><br>
            <ul class="list-disc ml-6">
              <li><strong>Packaging:</strong> Cleanrooms may be used in the food industry for the packaging of sterile products to prevent contamination.</li>
              <li><strong>Beverage Production:</strong> Cleanrooms play a role in maintaining the cleanliness of bottles and food packaging in hygienic environments.</li>
            </ul>
          </li>

        </ol>

        <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
          * Customized sizes are also available.
        </p>
        </div>
      </section>
      `,
      descriptionfive: `
      <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">

        <ol class=" ml-6 text-black font-['Neue Montreal'] !text-[18px] !leading-[32px] !font-medium space-y-4">

         <li>
            <strong>8. Hospitals and Healthcare:</strong><br>
            <ul class="list-disc ml-6">
              <li>Cleanroom conditions are essential in hospital pharmacies and surgical procedure rooms to minimize the risk of infections during special procedures.</li>
            </ul>
          </li>

          <li>
            <strong>Automotive Industry:</strong><br>
            <ul class="list-disc ml-6">
              <li><strong>Painting and Coating:</strong> Cleanrooms are used in automotive manufacturing for painting and coating processes to prevent dust and particle contamination.</li>
              <li><strong>Assembly & Quality Control:</strong> Assembling electronic components in automotive manufacturing also requires clean environments to ensure reliability.</li>
            </ul>
          </li>

        </ol>

        <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
          * Customized sizes are also available.
        </p>
        </div>
      </section>
      `
    },
    {
      id: "product-10",
      image: product_img10_1,
      alt: "Cubicle Storage Cabinet",
      title: "Cubicle Storage Cabinet",
      url: "cubicle-storage-cabinet",
      relateproimage: [
        pr10bg2,pr10bg3
      ],
      description: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Cubicle Storage Cabinet</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            The Cubicle storage cabinets provide an ultra-clean storage space to ensure clean, sterile and safe storing of precious materials including Cleanroom apparels, etc. The sterile storage cabinets consist of UV Lamp for sterilization, IR Lamp to maintain the temperature and glass doors. Front door is provided with interlocking arrangement for automatic UV cut-off when the door is opened. Multistage horizontal partition is provided for more storage space.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Cleans Sterile Storage Cabinets are available in Galvanized Iron 18 SWG sheet metal with polyurethane paint coated finish construction or made of IS 304 grade stainless steel sheet.
          </p>

          <p class="text-black font-['Neue Montreal'] mb-[16px] text-[18px] font-normal leading-[28px]">
            <span class="font-bold">Available in the following sizes :</span>
          </p>

          <table class="w-full text-left border-collapse md:!w-[500px]">
            <thead>
              <tr class="bg-[#1595B2]">
                <th class="p-2 border text-center text-white text-[16px]  !font-medium">Model No</th>
                <th class="p-2 border text-center text-white text-[16px] !font-medium">Width mm Inner/Outer</th>
                <th class="p-2 border text-center text-white text-[16px] !font-medium">Depth mm Inner/Outer</th>
                <th class="p-2 border text-center text-white text-[16px] !font-medium">Height mm Inner/Outer</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CSC 324</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">900 / 1000</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">600 / 650</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1200 / 1900</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CSC 424</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1200 / 1300</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">600 / 650</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1200 / 1900</td>
              </tr>
            </tbody>
          </table>

          <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
            * Customized sizes are also available.
          </p>

        </div>
        </section>
      `
    },
    {
      id: "product-11",
      image: product_img11,
      alt: "Powder sampling Booth/Dispensing Booth",
      title: "Powder sampling Booth",
      url: "Powder-sampling-Booth-Dispensing-Booth",
      relateproimage: [
        pr11bg1,pr11bg2
      ],
      description: `
       <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Powder sampling Booth / Dispensing Booth</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            The HEPA-filtered vertical airflow Laminar storage cabinets provide an ultra-clean 
            storage space to ensure clean, sterile and safe storing of precious materials including 
            Cleanroom apparels, etc. The sterile storage cabinets consist of UV Lamp for 
            sterilization, IR Lamp to maintain the temperature and glass doors. Front door is 
            provided with interlocking arrangement for automatic UV cut-off when the door is 
            opened. Multistage horizontal partition is provided for more storage space.
          </p>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Cleans Sterile Storage Cabinets are available in Galvanized Iron 18 SWG sheet metal 
            with polyurethane paint coated finish construction or made of IS 304 grade stainless 
            steel sheet.
          </p>

          <p class="text-black font-['Neue Montreal'] mb-[16px] text-[18px] font-normal leading-[28px]">
            <span class="font-bold">Available in the following sizes :</span>
          </p>

          <table class="w-full text-left border-collapse md:!w-[500px]">
            <thead>
              <tr class="bg-[#1595B2]">
                <th class="p-2 border border-white text-center text-white text-[16px] !font-medium">Model No</th>
                <th class="p-2 border border-white text-center text-white text-[16px] !font-medium">Length in mm</th>
                <th class="p-2 border border-white text-center text-white text-[16px] !font-medium">Depth in mm</th>
                <th class="p-2 border border-white text-center text-white text-[16px] !font-medium">Height in mm</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CPS 326</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">900</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">600</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2000</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CPS 436</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1200</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">900</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2000</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CPD 446</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1200</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1200</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2000</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CPD 646</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1800</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1200</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2000</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CPD 666</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1800</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1800</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2000</td>
              </tr>
              <tr class="border">
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">CPD 866</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2400</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">1800</td>
                <td class="p-[10px] text-center font-[500] border-white border bg-[#C2F0FA]">2000</td>
              </tr>
            </tbody>
          </table>

          <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
            * Customized sizes are also available.
          </p>

         </div>
        </section>
      `
    },
    {
      id: "product-12",
      image: product_img12,
      destwoimg: chage2,
      desthreeimg: chage3,
      desfourimg: chage4,
      desfiveimg: chage5,
      dessiximg: chage6,
      dessevenimg: chage7,
      alt: "Airflow Units",
      title: "Airflow Units",
      url: "airflow-units",
      relateproimage: [
        pr8bg1,pr8bg2,pr8bg3
      ],
      descriptionone: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Airflow Units</h1>

          <h2 class="text-[#1595B2] md:!text-[28px] !text-[22px] !font-bold">Laminar Airflow</h2>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Ceiling Suspended Laminar Air Flow system by clean flow Systems that sets a new standard for clean air quality.
            It is designed with a strong focus on providing exceptional air purity, laminar air flow, energy efficiency,
            and a user-friendly interface for Easy operation.
          </p>
          <p class="!text-[18px] !leading-[32px] !font-medium">
            Cleans Ceiling Suspended Laminar Airflow provides ultra clean sterile CLASS 100 clean air in specific area for various kinds of critical and highly sensitive activities are carried-out such as filling, bottling, turn-table or any other post- Operative health care is designed as per CLASS 5 OF ISO 14644-1 standards. Access for replacing HEPA filters will be provided from the bottom.
          </p>
          <p class="!text-[18px] !leading-[32px] !font-medium">
            Available in various sizes and in different type of fabrication material such as IS 304 SS, IS 316 SS or powder coated GSS. Cleans CLAF provided with differential pressure gauge and 
            transparent flexible strip curtains can be provided on request. Either inbuilt or stand-alone control panel with optional LED indicator provided. Ceiling Suspended Laminar Air Flow systems for various applications in the following areas:
          </p>
          <ul class="!space-y-3 !font-medium"> 
           <li>∙ Bio-Technology</li>
           <li>∙ Nano-Technology</li>
           <li>∙ R&D Laboratory</li>
           <li>∙ Electronics Manufacturing</li>
           <li>∙ Medical Industry</li>
           <li>∙ Food Processing Industry</li>
          </ul>

          <p class="mt-4 text-black font-['Neue Montreal'] !font-medium text-[16px]">
            * Customized sizes are also available.
          </p>
        </div>
        </section>
      `,
      descriptiontwo: `
        <section class="font-['Neue Montreal']">
          <div class="!space-y-[16px]">
            <h2 class="text-[#1595B2] md:!text-[28px] !text-[22px] !font-bold">Mobile Laminar Airflow</h2>

            <p class="!text-[18px] !leading-[32px] !font-medium">
              Mobile Laminar Airflow units (or Mobile LAF trolleys) are 
              portable devices that deliver a clean, particle-free environment in localized 
              areas—such as laboratory work benches or hospital wards—by generating a 
              unidirectional, laminar stream of HEPA-filtered air. These create ISO 5 class clean 
              zones on demand, improving contamination control in environments like labs or 
              during surgical procedures. Flexibility, ease of movement, and adaptability to 
              different tasks make them valuable assets.
            </p>
          </div>
        </section>
      `,
      descriptionthree: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h2 class="text-[#1595B2] md:!text-[28px] !text-[22px] !font-bold">Operation Theatre Laminar Airflow</h2>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Operation Theatre Laminar Airflow - In operating theatres, Laminar Airflow systems 
            utilize HEPA-filtered, unidirectional air flow—most often vertically downward—to 
            maintain an extremely low-turbulence, sterile environment over the operating field. 
            This helps reduce bacterial contamination and infection risk. These systems can be 
            ceiling-mounted panels or diffusers passing the air directly downward in a consistent 
            flow, commonly coupled with air curtains or airflow boundaries to isolate the sterile 
            zone.
          </p>
        </div>
        </section>
      `,
      descriptionfour: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h2 class="text-[#1595B2] md:!text-[28px] !text-[22px] !font-bold">Air Curtains</h2>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Air Curtains - Air curtains are streams (or "curtains") of high-velocity air across open 
            spaces, designed to separate zones—such as a sterile surgical area or 
            cleanroom—from surrounding environments without a physical barrier. In hospital 
            ORs, they typically consist of perimeter slot diffusers and laminar flow diffusers 
            above a surgical zone. The airflow helps minimize contamination by preventing 
            mixing between zones.
          </p>
        </div>
        </section>
      `,
      descriptionfive: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h2 class="text-[#1595B2] md:!text-[28px] !text-[22px] !font-bold">Ceiling Suspended Laminar Airflow</h2>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Ceiling Suspended Laminar Airflow - Ceiling-suspended Laminar Airflow refers to 
            large-area filtration modules installed flush with the ceiling to produce continuous 
            low-turbulence, unidirectional (usually vertical) airflow at a controlled 
            velocity—typically 0.3–0.5 m/s—creating a "protective zone" below the ceiling 
            where the operating table or sterile workstation is located. These are commonly 
            used in operating theatres to ensure clean airflow over critical surgical areas.
          </p>
        </div>
        </section>
      `,
      descriptionsix: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h2 class="text-[#1595B2] md:!text-[28px] !text-[22px] !font-bold">Pressure Module</h2>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Pressure Module - "Pressure Module" systems are modular, configurable cleanroom 
            or isolation units designed to maintain specific air pressure differentials—positive or 
            negative—via controlled airflow and filtration. Though not explicitly illustrated 
            above, these are standalone modules used in labs, hospitals, or manufacturing to 
            segregate areas with differing contamination risks. They rely on careful pressure 
            control to prevent cross-contamination and to manage sterile conditions.
          </p>
        </div>
        </section>
      `,
      descriptionseven: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h2 class="text-[#1595B2] md:!text-[28px] !text-[22px] !font-bold">Air Handling Units</h2>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Air handling units - An Air Handling Unit (AHU) is a central component of Heating, 
            Ventilation, and Air Conditioning (HVAC) systems, designed to regulate and circulate 
            air in large buildings such as hospitals, cleanrooms, factories, and commercial 
            spaces. It is typically a large metal box containing various components that work 
            together to clean, cool/heat, humidify/dehumidify, and distribute air throughout the 
            facility.
          </p>
        </div>
        </section>
      `,
    },
    {
      id: "product-13",
      image: product_img13,
      alt: "Pressure Module",
      title: "Pressure Module",
      url: "pressure-module",
      relateproimage: [
        pr13bg1,pr13bg2,pr13bg3
      ],
      description: `
        <section class="font-['Neue Montreal']">
        <div class="!space-y-[16px]">
          <h1 class="text-[#1595B2] md:!text-[32px] !text-[24px] !font-bold">Pressure Module</h1>

          <p class="!text-[18px] !leading-[32px] !font-medium">
            Cleans" Positive/Negative Pressure Modules Designed for Ambient clean down 
            these modules are available in a variety of versions, ceiling suspended, table top, 
            wall mounted and floor standing Capacities range from 150 CFM to 1500 CFM. 
            While the larger modules are intended for use in production areas, the smaller and 
            more compact units are designed to reduce considerably the over all biologic and 
            non biologic airborne particulate activity level. Especially in microbiological 
            laboratories, intensive care area in hospitals, conference rooms.
          </p>

          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="!h-[42px]">
                <th class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] !font-medium">Product</th>
                <th class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] !font-medium">Cleans" Positive Pressure Module</th>
              </tr>
            </thead>
            <tbody>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Type</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Window Mounted / Ceiling Suspended type</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Dimensions</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">As per drawings enclosed</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">MOC</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Galvanized Iron with PU coated / Stainless Steel – Satin Finish</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Pre Filter</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Cleans" Make Pre Filter with Micro Glass Fibre Media of EU – 4 Rating</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Supply HEPA Filter</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Imported Minipleate HEPA Filter efficiency 99.97% Down to 0.3µ H-13 Rating</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Motor Blower Assembly</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Induction Motor with Centrifugal Blower Statically and Dynamically balanced with Suitable Rating and Size</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Mounting Performance</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Unique Spring Suspension Systems to take care of Vibration and Noise.</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Air Cleanliness</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Class ISO – 5 (as per ISO – 14644-1) First air from the filter</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Air Flow Capacity</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">250 CFM/ 500 CFM/ 750 CFM/1000 CFM</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Noise Level</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Less than 67 db on Scale 'A' When Ambient sound Level is not Greater than 57 d</td>
              </tr>
              <tr class="!h-[42px]">
                <td class="border border-white text-start text-white bg-[#1595B2] pl-1 md:!w-[200px] !w-[140px] text-[14px] font-normal">Vibration Level</td>
                <td class="border border-white text-start text-black bg-[#C2F0FA] pl-1 text-[14px] font-normal">Minimum</td>
              </tr>
            </tbody>
          </table>

          </div>
        </section>
      `
    },
  ]
};

export default productData